app.component('foodbalanceResult', {
    templateUrl: 'app/foodbalance/basiccheckresult.html',
    controller: function( sharedDataRegionService, localStorageAccess ) {
        var $ctrl = this;
        $ctrl.$onInit = function() {
            // バランスチェック結果取得
            $ctrl.odmResult = sharedDataRegionService.getBalanceOdmResult();
            $ctrl.nowDate = moment().format("YYYY.MM.DD");
            // 結果をローカルストレージへ保存
            localStorageAccess.setData("balance", { "last": $ctrl.nowDate, "score" : $ctrl.odmResult.score });
        };
    }
});
